import { Flex, Skeleton } from '@eqi-investimentos/react';
import { SVGSkeleton } from '@/components/atoms/Skeleton';
export const LoadingBrokerSection = () => <Flex w="full" flexDir="column" gap="s" data-sentry-element="Flex" data-sentry-component="LoadingBrokerSection" data-sentry-source-file="Skeleton.tsx">
    <Skeleton w="350px" h="22px" data-sentry-element="Skeleton" data-sentry-source-file="Skeleton.tsx" />
    <Flex flexDir="row" gap="s" w="full" data-sentry-element="Flex" data-sentry-source-file="Skeleton.tsx">
      {Array.from({
      length: 3
    }).map((_, index) => <Skeleton key={index} w="80px" h="22px" />)}
    </Flex>
    <Flex flexDir="column" data-sentry-element="Flex" data-sentry-source-file="Skeleton.tsx">
      {Array.from({
      length: 21
    }).map((_, index) => <Flex key={index} flexDir="row" gap="s" borderBottom="1px solid" borderColor="border.secondary" py="s">
          <Skeleton w="30px" h="30px" />
          <Skeleton w="200px" h="30px" />
        </Flex>)}
    </Flex>
  </Flex>;